import React from 'react';
import { AppProvider } from './components/AppContext';
import NavBar from './components/NavBar';
import './App.css';
import MapViewer from './components/MapViewer';
import ControlPanel from './components/ControlPanel';
import LegendContent from './components/LegendContent';

function App() {

  return (
    <AppProvider>
      <div className="app">
        <div className="navbar">
          <NavBar/>          
        </div>
        <div className="mapContainer">
          <div className="mapSection">
            <MapViewer/>
            {/* <LegendContent/> */}
          </div>
          <ControlPanel/>  
        </div>
      </div>
    </AppProvider>
  );
}

export default App;
